module.exports = __webpack_public_path__ + "static/media/filter-primary.d31ab3a3.svg";